import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Form,
  Input,
  InputNumber,
  Select,
  Table,
  TableColumnsType,
} from "antd";
import styles from "./table.module.less";
import { Trash2 } from "lucide-react";
import { useState } from "react";
import { unitOptions } from "@/constants";
import { useTranslation } from "react-i18next";

export function PRATableList({ disabled }: { disabled: boolean }) {
  const { t } = useTranslation("inquiryManagement");
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);

  return (
    <Form.List name="itemList">
      {(fields, { add, remove }) => {
        const columns: TableColumnsType<any> = [
          {
            title: t("序号"),
            dataIndex: "index",
            width: 80,
            align: "center",
            fixed: "left",
            render: (_, __, index) => {
              const isHover = hoverIndex === index && !disabled;
              return isHover ? (
                <div
                  className={styles.removeIcon}
                  onClick={() => remove(index)}
                >
                  <Trash2 size={20} />
                </div>
              ) : (
                index + 1
              );
            },
          },
          {
            title: t("物料编号"),
            dataIndex: "materialCode",
            align: "center",
            width: 140,
            render: (_, field, index) => (
              <Form.Item name={[field.name, "materialCode"]} noStyle>
                <Input placeholder={t("请输入")} maxLength={100} />
              </Form.Item>
            ),
          },
          {
            title: t("物料名称（中文）"),
            dataIndex: "materialNameCn",
            align: "center",
            width: 140,
            render: (_, field, index) => (
              <Form.Item name={[field.name, "materialNameCn"]} noStyle>
                <Input placeholder={t("请输入")} maxLength={100} />
              </Form.Item>
            ),
          },
          {
            title: t("物料名称（英文）"),
            dataIndex: "materialNameEn",
            align: "center",
            width: 140,
            render: (_, field, index) => (
              <Form.Item name={[field.name, "materialNameEn"]} noStyle>
                <Input placeholder={t("请输入")} maxLength={100} />
              </Form.Item>
            ),
          },
          {
            title: t("商品名称（如有）"),
            dataIndex: "productName",
            align: "center",
            width: 140,
            render: (_, field, index) => (
              <Form.Item name={[field.name, "productName"]} noStyle>
                <Input placeholder={t("请输入")} maxLength={100} />
              </Form.Item>
            ),
          },

          {
            title: t("药典"),
            dataIndex: "pharmacopoeia",
            align: "center",
            width: 130,
            render: (_, field, index) => (
              <Form.Item name={[field.name, "pharmacopoeia"]} noStyle>
                <Input placeholder={t("请输入")} maxLength={100} />
              </Form.Item>
            ),
          },

          {
            title: t("标准"),
            dataIndex: "specification",
            align: "center",
            width: 130,
            render: (_, field, index) => (
              <Form.Item name={[field.name, "specification"]} noStyle>
                <Input placeholder={t("请输入")} maxLength={100} />
              </Form.Item>
            ),
          },

          {
            title: t("数量"),
            dataIndex: "quantity",
            align: "center",
            width: 130,
            render: (_, field, index) => (
              <Form.Item name={[field.name, "quantity"]} noStyle>
                <InputNumber min={1} precision={0} placeholder={t("请输入")} />
              </Form.Item>
            ),
          },
          {
            title: t("数量单位"),
            dataIndex: "quantityUnit",
            align: "center",
            width: 130,
            render: (_, field) => (
              <Form.Item name={[field.name, "quantityUnit"]} noStyle>
                <Select style={{ width: "100%" }} options={unitOptions} />
              </Form.Item>
            ),
          },

          {
            title: t("备注"),
            dataIndex: "remarks",
            align: "center",
            width: 130,
            render: (_, field, index) => (
              <Form.Item name={[field.name, "remarks"]} noStyle>
                <Input placeholder={t("请输入")} maxLength={200} />
              </Form.Item>
            ),
          },
        ];

        return (
          <>
            <Table
              bordered
              dataSource={fields}
              pagination={false}
              scroll={{ x: 1200 }}
              onRow={(_, index) => ({
                onMouseEnter: () => setHoverIndex(index!),
                onMouseLeave: () => setHoverIndex(null),
              })}
              columns={columns}
            ></Table>

            <Button
              hidden={disabled}
              icon={<PlusOutlined />}
              onClick={() => add({})}
              variant="outlined"
              color="primary"
              className={styles.addBtn}
            >
              {t("添加物料行")}
            </Button>
          </>
        );
      }}
    </Form.List>
  );
}
